import React from 'react';
import './SettingCardContent.css';

export interface SettingCardContentProps {
	children: React.ReactNode;
	className?: string;
}

export const SettingCardContent: React.FC<SettingCardContentProps> = ({
	children,
	className = '',
}) => {
	return <div className={`setting-card-content ${className}`.trim()}>{children}</div>;
};
